import {
  DashboardModule, Form,
} from '@domain-group/suit-theme'

import { useAdAccountGroupForm } from '@hooks/useAdAccountGroup'
import useProductLines from '@hooks/useProductLines'

interface AdAccountGroupDetailsProps {
  adAccountGroupFormPayload: ReturnType<typeof useAdAccountGroupForm>,
}

const AdAccountGroupDetails = (props: AdAccountGroupDetailsProps) => {
  const {
    adAccountGroupFormPayload: {
      entityState: {
        name,
        productLineId,
      },
      errors,
      handlers,
    },
  } = props

  const { productLines } = useProductLines({ performHttpRequests: true })

  return (
    <DashboardModule title="Ad Account Group Details">
      <Form padding="large">
        <Form.Row>
          <Form.Field errorMessage={errors.name} label="* Name">
            <input
              name="name"
              value={name}
              type="text"
              {...handlers}
            />
          </Form.Field>

          <Form.Field errorMessage={errors.productLineId} label="* Product Line">
            <select name="productLineId" value={productLineId} {...handlers}>
              <option value="">None</option>
              {productLines.map(productLine => (
                <option key={productLine.id} value={productLine.name}>{productLine.displayName}</option>
              ))}
            </select>
          </Form.Field>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

export default AdAccountGroupDetails
